// src/redux/classSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  get_admitcard,
  add_admitcard,
  update_admitcard,
  delete_admitcard,
} from "../Service/ApiServices.js";
import { toast } from "react-toastify";

const initialState = {
  admitcards: [],
  school_id: "",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    exam: "",
  },
};

// Async Thunks for API Calls
export const fetchadmitcard = createAsyncThunk(
  "admitcard/fetchadmitcard",
  async ({ exam,session,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_admitcard(exam,session, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createadmitcard = createAsyncThunk(
  "admitcard/createadmitcard",
  async ({ data, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_admitcard(data, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateadmitcard = createAsyncThunk(
  "admitcard/updateadmitcard",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_admitcard(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteadmitcard = createAsyncThunk(
  "admitcard/deleteadmitcard",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_admitcard({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// Class Slice
const admitcardSlice = createSlice({
  name: "admitcards",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    updateFilterData(state, action) {
      const { name, value } = action.payload;
      state.filterData[name] = value;
    },
    EditFormData(state, action) {
      // The action should contain all the fields that need to be updated
      const { id, exam } = action.payload;
      state.formData = {
        id,
        exam,
      };
    },
    resetFormData(state) {
      state.formData = {
        exam: "",
      };
    },
    setadmitcard(state, action) {
      state.admitcards = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Classes
      .addCase(fetchadmitcard.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchadmitcard.fulfilled, (state, action) => {
        state.loading = false;
        state.admitcards = action.payload;
      })
      .addCase(fetchadmitcard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.admitcards = [];
      })

      // Add Class
      .addCase(createadmitcard.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createadmitcard.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        if (action.payload?.created?.length) {
          state.admitcards = state.admitcards.map((item) => {
            const match = action.payload.created.find(
              (c) => c.student === item.student.id
            );
            if (match) {
              return {
                ...item,
                not_generated: false, 
                id: match.id, 
              };
            }
            return item;
          });
        }
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createadmitcard.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update Class
      .addCase(updateadmitcard.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateadmitcard.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
         if (action.payload?.updated?.length) {
    state.admitcards = state.admitcards.map((item) => {
      const match = action.payload.updated.find((c) => c.id === item.id);
      if (match) {
        return {
          ...item,
          is_released: match.is_released,
        };
      }
      return item;
    });
  }
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateadmitcard.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;

        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete Class
      .addCase(deleteadmitcard.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteadmitcard.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteadmitcard.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  setadmitcard,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize,
  updateFilterData,
} = admitcardSlice.actions;
export default admitcardSlice.reducer;
